export const validateName = (name, prohibitedWords) => {
  if (name.length < 2) {
    alert("이름은 최소 2글자 이상이어야 합니다.");
    return false;
  }

  if (name.length > 20) {
    alert("이름은 20자 이하여야 합니다.");
    return false;
  }

  // 금지어 검사
  for (const word of prohibitedWords) {
    if (name.includes(word)) {
      alert("이름에 부적절한 단어가 포함되어 있습니다.");
      return false;
    }
  }

  return true;
};

export const validatePhoneNumber = (phoneNumber) => {
  const fullPhoneNumber =
    phoneNumber.first + phoneNumber.second + phoneNumber.third;

  if (fullPhoneNumber.length < 9) {
    alert("전화번호를 정확히 입력해주세요.");
    return false;
  }

  const phoneRegex = /^[0-9]{9,14}$/;
  if (!phoneRegex.test(fullPhoneNumber)) {
    alert("전화번호를 정확히 입력해주세요.");
    return false;
  }

  // 가운데 + 끝 번호를 합친 문자열이 동일한 숫자로만 이루어졌는지 검사
  const middleAndLast = phoneNumber.second + phoneNumber.third;
  const allSame = /^(\d)\1+$/;
  if (allSame.test(middleAndLast)) {
    alert("전화번호에 동일한 숫자가 반복될 수 없습니다.");
    return false;
  }

  return true;
};
